import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=77265956&scoped=true&"
import script from "./ShopList.vue?vue&type=script&lang=js&"
export * from "./ShopList.vue?vue&type=script&lang=js&"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=77265956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77265956",
  null
  
)

export default component.exports